import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { storeQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeftIcon } from '@yonderland/andes-icons';
import { Icon, IconButton, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { PERSONAL_SHOPPING_ADVICE_STORAGE_KEY, SHOP_NUMBER_STORAGE_KEY } from '../../constants/StorageKeysConstants';
import LocalStorageUtil from '../../util/LocalStorageUtil';
import { getQuerystringByName } from '../../util/URLParamUtil';
const resolveShopNumber = (configShopNumber) => {
    if (typeof window === 'undefined') {
        return configShopNumber;
    }
    const fromUrl = getQuerystringByName(window.location.search, SHOP_NUMBER_STORAGE_KEY) ||
        getQuerystringByName(window.location.hash, SHOP_NUMBER_STORAGE_KEY);
    if (fromUrl)
        return fromUrl;
    const fromStorage = LocalStorageUtil.getJsonItem(SHOP_NUMBER_STORAGE_KEY);
    if (fromStorage)
        return fromStorage;
    return configShopNumber;
};
const isPersonalShoppingAdviceEnabled = () => LocalStorageUtil.getJsonItem(PERSONAL_SHOPPING_ADVICE_STORAGE_KEY) === 'true';
const HeaderShopLandingInfo = () => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const { defaultRequestParams, servicesEndpoint, shopNumber } = useAemConfig();
    const [psaEnabled, setPsaEnabled] = useState(false);
    useEffect(() => {
        setPsaEnabled(isPersonalShoppingAdviceEnabled());
    }, []);
    const resolvedShopNumber = resolveShopNumber(shopNumber);
    const { getShopLandingStoreInfo } = storeQueries({ servicesEndpoint, defaultRequestParams });
    const { data: store } = useQuery(getShopLandingStoreInfo({ shopNumber: resolvedShopNumber }, { enabled: !!resolvedShopNumber }));
    const handleBackClick = () => {
        window.history.back();
    };
    return (_jsxs(Stack, { align: "center", gap: "3", wrap: "nowrap", children: [_jsx(IconButton, { testId: "shoplanding-header-back", variant: "secondary", size: "sm", ariaLabel: t('navigation.shoplanding.back'), onClick: handleBackClick, children: _jsx(Icon, { source: ArrowLeftIcon, size: "sm", color: "neutral" }) }), _jsxs("div", { children: [(store === null || store === void 0 ? void 0 : store.name) && _jsx(TextAlpha, { testId: "shoplanding-header-store-name", children: store.name }), psaEnabled && (_jsx(TextAlpha, { as: "div", variant: "bodyS", color: "subtle", testId: "shoplanding-header-psa", children: t('navigation.shoplanding.psa') }))] })] }));
};
export default HeaderShopLandingInfo;
